import type { RuleSet } from './types.js';

export const ENGLISH_DRAUGHTS: RuleSet = {
  id: 'english',
  boardSize: 8,
  startingRows: 3,
  piecesOnDarkSquares: true,
  manCapturesBackward: false,
  flyingKings: false,
  maxCaptureRequired: false,
  promoteMidJump: false,
  drawAfterQuietMoves: 40,
  firstPlayer: 'black',
};
